<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="medium-width">
    <input matInput autocomplete="off" formControlName="Name" placeholder="Nombre">
  </mat-form-field>
  <mat-checkbox formControlName="ShowSend">Ver enviados</mat-checkbox>
  <mat-checkbox formControlName="ShowDeleted">Ver deshabilitados</mat-checkbox>
</form>
